var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('InfoCard',{attrs:{"title":""}},[(_vm.$store.state.transport.consignment)?_c('QrCode',{attrs:{"consignmentId":_vm.$store.state.transport.consignment.id}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }